<script lang="ts">
	import type { BadgeColor } from '$lib/components/atoms/badge/types';
	import type { IconName } from '$lib/components/icons/types';
	import errorImage from '$assets/pois/default.webp';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import * as m from '$paraglide/messages';

	export let src: string;
	export let color: BadgeColor;
	export let icon: IconName | undefined = undefined;
</script>

<div class="image-container relative">
	<Image
		class="image h-full w-full rd-2"
		alt={m.poi_card__image_alt()}
		eager
		{src}
		fallbackSrc={errorImage}
	/>
	{#if icon}
		<div class="absolute top-1 right-1">
			<Badge {icon} {color} />
		</div>
	{/if}
</div>

<style>
	.image-container {
		width: 120px;
		min-height: 120px;
	}
</style>
